export default __webpack_public_path__ + "static/media/unsplash.54855635.jpg";